export default class missionManager {
    constructor(param) {

        // kv
        this.kv = document.getElementById("p-kv");
        this.kvPhoto = document.getElementById("p-kv__bg");
        if(param.browserType !== 'IE'){
            TweenMax.set(this.kvPhoto,{ opacity:0,scale:1.08});
        }

        this.param = param;
        this.anime = '';

    }
    init(){


    }

    splash(){

        if(this.param.browserType !== 'IE'){
            TweenMax.to(this.kvPhoto,3.2,{
                opacity:1,
                ease: "Power2.easeOut"
            });
            this.anime = TweenMax.to(this.kvPhoto,14,{
                scale:1,
                ease: "Power2.easeOut",
            });
        }

    }

    render(_y,_h){

        if(_y > _h){
            if(this.anime === '') return;
            this.anime.pause(14);
        }

    }
    resize(_w,_h,_display){


    }


}